export const ADDRESS_UNAVAILABLE = 'Address not available';

const EARTH_RADIUS_KM = 6371;

const toRad = (degrees) => degrees * (Math.PI / 180);

/**
 * Haversine distance between two coordinates.
 * @returns {number} Distance in kilometres, rounded to 1 decimal place
 */
export const calculateDistance = (lat1, lon1, lat2, lon2) => {
  const dLat = toRad(lat2 - lat1);
  const dLon = toRad(lon2 - lon1);

  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) *
    Math.sin(dLon / 2) * Math.sin(dLon / 2);

  const distance = EARTH_RADIUS_KM * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

  return Math.round(distance * 10) / 10;
};

/**
 * Whether two { latitude, longitude } points are within `tolerance` degrees on both axes.
 * Used to decide whether cached weather belongs to the same place.
 */
export const isNearLocation = (a, b, tolerance = 0.1) =>
  Boolean(a && b) &&
  Math.abs(a.latitude - b.latitude) < tolerance &&
  Math.abs(a.longitude - b.longitude) < tolerance;

/**
 * Google Maps search URL for a place type near a location, e.g. "pubs".
 * Used as an honest fallback when our own venue lookup fails.
 */
export const buildMapsSearchUrl = (placeType, { latitude, longitude }) => {
  const query = encodeURIComponent(`${placeType} near ${latitude},${longitude}`);
  return `https://www.google.com/maps/search/?api=1&query=${query}`;
};

/**
 * Format a street address from OpenStreetMap addr:* tags.
 */
export const formatAddress = (tags) => {
  const parts = [
    tags['addr:housenumber'],
    tags['addr:street'],
    tags['addr:suburb'],
    tags['addr:city'],
    tags['addr:postcode'],
  ].filter(Boolean);

  return parts.length > 0 ? parts.join(', ') : ADDRESS_UNAVAILABLE;
};
